import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-play-icon",
  "use": "spr-play-icon-usage",
  "viewBox": "0 0 23 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 23 30\" id=\"spr-play-icon\"><defs><path id=\"spr-play-icon_a\" d=\"M1246.92 1222.89a1 1 0 0 1-1-1v-27.97a1 1 0 0 1 1.56-.82l21.03 14.4a.99.99 0 0 1-.02 1.64l-6.69 4.32a1 1 0 0 1-1.08-1.66l5.44-3.51-18.25-12.5v24.29l1.9-1.23a1 1 0 0 1 1.08 1.66l-3.43 2.22a1 1 0 0 1-.54.16zm6.4-4.14a1 1 0 0 1-.53-1.82l4.96-3.2a.99.99 0 1 1 1.08 1.66l-4.96 3.2a.98.98 0 0 1-.54.16z\" /></defs><use xlink:href=\"#spr-play-icon_a\" transform=\"translate(-1246 -1193)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/play-icon.svg
// module id = 277
// module chunks = 0